import React from 'react';
import { Text, TextTypography } from 'wix-ui-tpa/cssVars';
import { classes } from './TitleSection.st.css';
import { useTitleSettings } from './useTitleSettings';
import { FormType } from '../../../types/types';
import { useStyles } from '@wix/tpa-settings/react';
import loginStylesParams from '../../Login/stylesParams';
import signupStylesParams from '../../Signup/stylesParams';
import { TEXT_DIRECTION } from '../../../constants';
import { useEnvironment } from '@wix/yoshi-flow-editor';

interface TitleSectionProps {
  formType: FormType;
  ssoMandatory: boolean;
  // Force the title/subtitle text and visibility, regardless of the site's signup-title settings.
  // Used by the complete-profile popup, which reuses the signup widget but needs its own heading.
  titleOverride?: string;
  subtitleOverride?: string;
}

export const TitleSection = ({
  formType,
  ssoMandatory,
  titleOverride,
  subtitleOverride,
}: TitleSectionProps) => {
  const { isTitleVisible, isSubtitleVisible, titleText, subtitleText } =
    useTitleSettings({ formType, ssoMandatory });

  const showTitle = titleOverride !== undefined || isTitleVisible;
  const showSubtitle = subtitleOverride !== undefined || isSubtitleVisible;
  const { isRTL } = useEnvironment();

  const styles = useStyles();

  const stylesParams =
    formType === 'login' ? loginStylesParams : signupStylesParams;

  const titleFont = styles.get(stylesParams.titleFont);

  return (
    <div
      className={classes.titleSection}
      dir={isRTL ? TEXT_DIRECTION.RTL : TEXT_DIRECTION.LTR}
    >
      {showTitle && (
        <Text
          data-hook={`${formType}-title`}
          typography={TextTypography.largeTitle}
          className={classes.title}
          tagName={titleFont?.htmlTag || 'h2'}
        >
          {titleOverride ?? titleText}
        </Text>
      )}
      {showSubtitle && (
        <Text data-hook={`${formType}-subtitle`} className={classes.subtitle}>
          {subtitleOverride ?? subtitleText}
        </Text>
      )}
    </div>
  );
};
